import { Autocomplete, Box, Button, Checkbox, Divider, FormControl, IconButton, Stack, TextField, Typography } from '@mui/material'
import { ChevronLeftIcon, ChevronRightIcon, DotIcon } from 'lucide-react';
import React, { useEffect, useState } from 'react'
import { RootState } from '../../../global/config/store';
import { useSelector } from 'react-redux';
import { format } from 'date-fns';
import { ApiGetAllocationlist, ApiGetBundleList, ApiGetClientEntityByClientGroupId } from '../../../apiService/Core/Apicall.tsx';
import { useNavigate } from 'react-router-dom';

function BundleAllocation() {

    const [task, settask] = React.useState<any>([]);
    const [currentDate, setCurrentDate] = useState(() => {
        const date = new Date();
        date.setMonth(date.getMonth() - 1);
        return date;
    }); const [reportMonth, setReportMonth] = useState<number>(currentDate.getMonth() + 1);
    const [reportYear, setReportYear] = useState<number>(currentDate.getFullYear());
    const Navigate = useNavigate()



    const handlePrevMonth = () => {
        setCurrentDate((prevDate) => {
            const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() - 1, 1);
            setReportMonth(newDate.getMonth() + 1);
            setReportYear(newDate.getFullYear());
            return newDate;
        });
    };

    useEffect(() => {
        const ApiBundleAllocation = async () => {
            const data = `?jobMonth=${reportMonth}&jobYear=${reportYear}`
            try {
                const response = await ApiGetBundleList(data)
                settask(response.data)

            } catch (error) {

                alert(error)
            }

        }
        ApiBundleAllocation()
    }, [reportMonth, reportYear])

    const handleNextMonth = () => {

        setCurrentDate((prevDate) => {
            const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() + 1, 1);
            setReportMonth(newDate.getMonth() + 1);
            setReportYear(newDate.getFullYear());
            return newDate;
        });

    };

    const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newDate = new Date(event.target.value + "-01");

        setCurrentDate(newDate);
        setReportMonth(newDate.getMonth() + 1);
        setReportYear(newDate.getFullYear());

    };

    return (
        <Box className='bg-white pt-5'>
            <h1 className="text-center">Bundle Allocations</h1>
            <div className="d-flex align-items-center justify-content-between px-3 mb-1">

                {/* <Box className='col-6 d-flex juastify-content-start'> */}
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        // marginTop: "20px"
                    }}
                >
                    <IconButton onClick={handlePrevMonth}>
                        <ChevronLeftIcon />
                    </IconButton>
                    <Box sx={{ display: "flex", alignItems: "center", mx: 2 }}>
                        <input
                            type="month"
                            onChange={handleDateChange}
                            value={format(currentDate, "yyyy-MM")}
                            className="primary-color"
                            style={{
                                border: "none",
                                background: "none",
                                fontSize: "1.25rem",
                                fontWeight: "bold",
                                cursor: "pointer",
                                fontFamily: "inherit",
                            }}
                        />
                    </Box>
                    <IconButton onClick={handleNextMonth}>
                        <ChevronRightIcon />
                    </IconButton>
                </Box>
                <Box className='extra'>
                    <Button className="bg-grey transform px-5 text-light" onClick={() => { Navigate('/admin/allocations/createbundle-allocations') }}>
                        Create
                    </Button>
                </Box>
            </div>
            <Divider className='mx-4 mb-2' />
            <Box minHeight='calc(100vh - 380px)' className='d-flex align-items-start  justify-content-between'>
                <Box className='col-12 h-100 p-3'>
                    <Box className='d-flex flex-wrap align-items-stretch justify-content-start' gap={2}>
                        {task.map((item: any) => (
                            <Box className='border d-flex align-items-start p-3 col-3' sx={{ borderRadius: '10px' }} maxWidth='24%'  gap={1} key={item.bundleId}>
                                <Box className='w-100'>
                                    <Typography lineHeight='1' fontWeight='bold' className='m-0 p-0' variant='h6'>{item.bundleName}</Typography>
                                    <Box className='mt-2 w-100'>
                                        <Typography fontWeight={700} variant='subtitle2'>Venue:&nbsp;</Typography>
                                        <ul  className='mt-1 w-100 d-flex flex-wrap'>
                                            {item?.venue?.map((items: any, index: number) => (
                                                <li className='d-flex col-6'><span><DotIcon/></span><Typography whiteSpace='wrap' key={index} className='fw-bold m-0 p-0' variant='subtitle2'>{items.venueName}</Typography></li>
                                            ))}
                                        </ul>
                                    </Box>

                                </Box>
                            </Box>

                        ))}
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default BundleAllocation
